"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validate = void 0;
const Agent_1 = __importDefault(require("../agent/Agent"));
class Validate {
    /**
     * Tests if storage key value are valid. It will throw
     * an exception if any of them is invalid
     * @param key Storage key
     * @param value Storage value
     * @param agent IAgent optional
     */
    static storageKeyValue(key, value, agent) {
        if (!key || !key.length) {
            throw Error('Key cannot be empty');
        }
        if (key.indexOf('/') !== -1) {
            throw Error("Key cannot contain '/'");
        }
        if (!value || !value.length) {
            throw Error('Value cannot be empty');
        }
        if (agent !== undefined && !(agent instanceof Agent_1.default)) {
            throw Error(`Invalid agent provided`);
        }
    }
}
exports.Validate = Validate;
//# sourceMappingURL=Validate.js.map